import React from 'react';
import './About.css'; 
import Footer from './Footer';


const AboutPage = () => {
  const boardMembers = [
    {
      id: 1,
      name: 'Dr. Sue Savage-Rumbaugh',
      role: 'Chair',
      image: 'sue-savage-rumbaugh-profile.jpg',
      description: 'lorem ipsum...',
      location: 'Des Moines, Iowa',
    },
    {
      id: 2,
      name: 'Dr. Nancy Howell',
      role: 'Professor of Theology and Religion, Saint Paul School of Theology',
      image: 'default.png',
      description: 'lorem ipsum...',
      location: 'Kansas City, Missouri',
    },
    {
      id: 3,
      name: 'Sebastian Lingomo',
      role: 'Director La Foret des Bonobose',
      image: 'sebastian-lingomo-profile.png',
      description: 'lorem ipsum...',
      location: 'Kinshasa, Democratic Republic of Congo',
    },
    {
      id: 4,
      name: 'Ms. Sally Coxe',
      role: 'President, Bonobo Conservation Initiative',
      image: 'sally-coxe-profile.png',
      description: 'Sally is president and co-founder of the Bonobo Conservation Initiative. Known as “Mama Bonobo,” Sally has worked tirelessly for over 20 years to protect bonobos, preserve the Congo rainforest, and empower Congolese communities as leaders in conservation. \n\nShe has led and managed the growing organization, including field operations in the DRC and development and outreach efforts in the USA and internationally. Since her first trip to the DRC (then Zaire) in 1994, Sally has been investigating local folklore and traditions regarding the relationship between humans and bonobos. This focus on indigenous wisdom and culture shaped and continues to inform BCI’s holistic conservation model. Under Sally’s leadership, BCI collaborates with partner organizations, the DRC government, and local communities to manifest their common vision for the Bonobo Peace Forest. This expanding network of community managed forests now includes two officially established nature reserves, spanning 9 million acres, and additional protected areas in development. Sally became fascinated with bonobos while Senior Copywriter at the National Geographic Society. She is a Phi Beta Kappa graduate of Williams College with honors in Psychology.',
      location: 'Des Moines, Iowa',
    },
    {
      id: 5,
      name: 'Dr. Carmen Mate',
      role: 'Professor, Department of Animal Biology, University of Barcelona',
      image: 'default.png',
      description: 'lorem ipsum...',
      location: 'Barcelona, Spain',
    },
    {
      id: 6,
      name: 'Mr. David Olisar',
      role: '',
      image: 'default.png',
      description: 'Dave spent many years traveling the world as a telecommunication industry executive. He found that as telecommunication networks were introduced and installed in remote parts of the world, the habitat for other species was disappearing. Now retired, he wants to do his part in securing the habitat and way of life of human’s closest relative, Bonobo, an endangered great ape. Dave attended graduate school at Carnegie Mellon University where he obtained his Master’s Degree in Computer and Electrical Engineering in 1980.',
      location: 'Naperville, Illinois',
    },
    {
      id: 7,
      name: 'Dr. Doug Pernikoff, MBA',
      role: '',
      image: 'default.png',
      description: 'lorem ipsum...',
      location: 'Des Moines, Iowa',
    },
    {
      id: 8,
      name: 'Dr. Itai Roffman',
      role: 'Lecturer and Researcher, Max Stern Yezreel Valley College',
      image: 'itai-roffman-profile.png',
      description: 'lorem ipsum...',
      location: 'Israel',
    },
    {
      id: 9,
      name: 'Shane Savage-Rumbaugh',
      role: 'Professor of Visual and Performing Arts, Stonehill College',
      image: 'shane-savage-rumbaugh-profile.png',
      description: 'lorem ipsum...',
      location: 'Easton, Massachusetts',
    },
    {
      id: 10,
      name: 'Dr. Paul Thibault',
      role: 'Professor of Linguistics and Media Communication, Agder University College',
      image: 'paul-thibault-profile.png',
      description: 'lorem ipsum...',
      location: 'Kristiansand, Norway',
    },
    {
      id: 11,
      name: 'Anysja Roberts',
      role: 'PhD Student, University of Kansas Medical Center',
      image: 'anysja-roberts-profile.png',
      description: 'lorem ipsum...',
      location: 'Overland Park, Kansas',
    },
    {
      id: 12,
      name: 'Julie Flaherty, JD',
      role: 'Attorney',
      image: 'default.png',
      description: 'lorem ipsum...',
      // location: 'Des Moines, Iowa',
    },
    // Add other board members here...
  ];

  const advisoryBoardMembers = [
    {
      id: 1,
      name: 'David Goldman, JD',
      role: 'Attorney, Babich Goldman, PC',
      image: 'default.png',
      description: 'lorem ipsum...',
      location: 'Des Moines, Iowa',
    },
    {
      id: 2,
      name: 'Amory Lovins',
      role: 'Founder and Chairman Emeritus, Rocky Mountain Institute',
      image: 'default.png',
      description: 'lorem ipsum...',
      location: 'Basalt, Colorado',
    },
    {
      id: 3,
      name: 'Zohara Hieronimus',
      role: 'Advisor',
      image: 'zoh_hieronimus_profile.jpg',
      description: 'lorem ipsum...',
      location: 'Des Moines, Iowa',
    },
    // Add other advisory board members here...
  ];

const renderMembersInRows = (members) => {
  const rows = [];
  let currentRow = [];

  // Sort the members by their IDs
  members.sort((a, b) => a.id - b.id);

  members.forEach((member, index) => {
    currentRow.push(
      <div key={member.id} className="board-member">
        <img src={`/${member.image}`} alt={member.name} />
        <h3>{member.name}</h3>
        <p className="member-role">{member.role}</p>
        <p className="member-location"><i className="fa fa-map-marker" ></i>  {member.location}</p>
        {/*<p className="member-description">{member.description}</p>*/}
      </div>
    );

    // Check if we have three members in the current row or if it's the last member
    if (currentRow.length === 3 || index === members.length - 1) {
      rows.push(<div className="board-row" key={rows.length}>{currentRow}</div>);
      currentRow = [];
    } else if (currentRow.length > 0) {
      // There are only 2 or 1 members in the current row, so add it to the rows array
      rows.push(<div className="board-row" key={rows.length}>{currentRow}</div>);
      currentRow = [];
    }
  });

  return rows;
};



  return (
    <div className="about-page">
      <section className="board-section">
        <h2 className="board-header">The Board</h2>
        <div className="board-members-container">{renderMembersInRows(boardMembers)}</div>
      </section>
      <section className="advisory-board-section">
        <h2 className="advisory-board-header">Advisory Board</h2>
        <div className="advisory-board-container">{renderMembersInRows(advisoryBoardMembers)}</div>
      </section>
    </div>
  );
};

export default AboutPage;
